__webpack_require__.p = "/zero-to-mastery/";